// extracted by mini-css-extract-plugin
export default {"wrapper":"NodeDomain_wrapper__0VzYI"};